const uiReducer = (state={online:true, calendar_view:true, premium_modal:false, video_muted:true}, action)=>{
  switch (action.type) {
    case 'MEDIA_MUTE':
     return {
       ...state,
       video_muted: action.payload,
    }
    case 'CHANGE_ONLINE_STATUS':
      return {
        online: action.online,
      }
    case 'OPEN_PREMIUM_MODAL':
      return {
        ...state,
        premium_modal:true
      }
    case 'CLOSE_PREMIUM_MODAL':
      return {
        ...state,
        premium_modal:false
      }
   default:
     return state || {}
 }
}


export default uiReducer;



// WEBPACK FOOTER //
// ./src/utils/reducers/ui.js